import { render, staticRenderFns } from "./RestorePassword.vue?vue&type=template&id=7b47db10&scoped=true&"
import script from "./RestorePassword.vue?vue&type=script&lang=ts&"
export * from "./RestorePassword.vue?vue&type=script&lang=ts&"
import style0 from "./RestorePassword.vue?vue&type=style&index=0&id=7b47db10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b47db10",
  null
  
)

export default component.exports